import { SetFiltersRequest, UpdateSettingsRequest } from '../grid/types/common';

export function getViewState(viewStateName: string): UpdateSettingsRequest<any> & SetFiltersRequest<any> {
  return Ext.state.Manager.get(viewStateName, {}) as UpdateSettingsRequest<any> & SetFiltersRequest<any>;
}

export function saveViewState(
  request: SetFiltersRequest<any> | UpdateSettingsRequest<any>,
  viewStateName: string
): void {
  const newState = getViewState(viewStateName);

  for (const property in request) {
    if (request.hasOwnProperty(property) && request[property] !== undefined) {
      newState[property] = request[property];
    }
  }
  Ext.state.Manager.set(viewStateName, newState);
}
